"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICING_PLAN_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';
exports.FEDOPS_WIDGET_APP_NAME = 'bookings-widget-phase-zero';
exports.SENTRY_BOOKINGS_WIDGET_DSN = 'https://a167926f5001408aa2483cc6f7b82bb1@sentry.io/1262034';
//# sourceMappingURL=bookings.const.js.map